/**
 * Extracts all keys from a nested object structure
 * @param {Object} dataObj - The object to extract keys from
 * @returns {Array} Array of all keys found in the object
 */
export function extractKeys(dataObj: any) {
  if (dataObj === undefined) {
    return [];
  }
  const keys = [];

  for (const [mainKey, value] of Object.entries(dataObj)) {
    // Add the main key if it's a string
    if (typeof mainKey === "string") {
      keys.push(mainKey);
    }

    // If value is an object, process its keys
    if (typeof value === "object" && value !== null) {
      for (const subKey of Object.keys(value)) {
        if (typeof subKey === "string") {
          keys.push(subKey);
        }
      }
    }
  }

  return keys;
}

/**
 * Extracts all numeric values from a nested object structure
 * @param {Object} dataObj - The object to extract values from
 * @returns {Array} Array of all numeric values found in the object
 */
export function extractValues(dataObj: any) {
  const values = [];

  for (const [_, value] of Object.entries(dataObj)) {
    // If value is a number, add it
    if (typeof value === "number") {
      values.push(value);
    }
    // If value is an object, process its values
    else if (typeof value === "object" && value !== null) {
      for (const subValue of Object.values(value)) {
        if (typeof subValue === "number") {
          values.push(subValue);
        }
      }
    }
  }

  return values;
}
